// extracted by mini-css-extract-plugin
export default {"footer":"checkbox-list-module__footer--mcX"};